
export enum ProgressConstants {
  FETCH_ALL_PROGRESS_SUCCESS = "FETCH_ALL_PROGRESS_SUCCESS",
  FETCH_ALL_PROGRESS_FAILURE = "FETCH_ALL_PROGRESS_FAILURE",
}
